import classNames from 'classnames';
import React from 'react';

import { Icon } from '@flixbus/honeycomb-icons-react';
import { Tag } from '@flixbus/honeycomb-react';

import { ASSIGNMENT_STATUSES } from 'pages/RideDetails/components/Assigment/const';
import { ASSIGNMENT_LABEL_TEXT } from 'pages/RideDetails/components/Assigment/text';
import { statusLabelIconMap } from 'utils/assigmentStatusToTagVariant';

import styles from './styles.module.css';

const AssignmentStatusTag = React.forwardRef(({ status, isVoided }, ref) => {
	const { label: statusLabel, icon } = statusLabelIconMap[status];
	const label = isVoided ? ASSIGNMENT_LABEL_TEXT.voided : statusLabel;

	const tagStyle = classNames({
		[styles.tag]: true,
		[styles.rejected]: status === ASSIGNMENT_STATUSES.REJECTED && !isVoided,
		[styles.voided]: isVoided,
		[styles.confirmed]: status === ASSIGNMENT_STATUSES.CONFIRMED,
		[styles.live]: status === ASSIGNMENT_STATUSES.LIVE,
		[styles.finished]: status === ASSIGNMENT_STATUSES.ACTUAL,
	});

	return (
		<Tag extraClasses={tagStyle} small display="subtle" ref={ref}>
			<Icon InlineIcon={icon} />
			{label}
		</Tag>
	);
});

AssignmentStatusTag.displayName = 'AssignmentStatusTag';

export default AssignmentStatusTag;
